<template>
  <div class="flex flex-row items-stretch">
    <div class="flex flex-row flex-wrap -m-2">
      <div
        class="w-24 h-32 overflow-hidden rounded-lg flex-shrink-0 m-2 relative"
        v-for="(file, index) in data"
        :key="index">
        <template v-if="typeof file === 'object'">
          <img
            class="h-full object-center object-cover w-full"
            :src="file.blob"
            alt=""
            v-if="file.blob">
        </template>
        <template v-else>
          <Attachment
            class="h-full object-center object-cover w-full"
            :id="file"/>
        </template>
        <div
          class="img-delete"
          @click="unset(file, index)"></div>
      </div>
    </div>
    <div
      class="ml-4 flex-shrink-0 flex-grow-0"
      :class="$classnames({
        'opacity-0 pointer-events-none': !canAdd,
      })">
      <VueUpload
        :class="$classnames([
          'flex',
          'flex-row',
          'items-center',
          'rounded-lg',
          'bg-primary',
          'p-6',
          'h-32',
        ])"
        ref="upload"
        v-model="data"
        :input-id="$uniqid()"
        :multiple="true"
        :maximum="maximum"
        @input-filter="onInputFilter"
        @input-file="onInputFile">
        <span class="text-white font-rubik text-12px leading-14px font-medium">
          Добавить фото
        </span>
      </VueUpload>
    </div>
  </div>
</template>

<script>
import VueUpload from 'vue-upload-component';
import Attachment from '@/components/global/Attachment.vue';

export default {
  props: {
    payload: {
      type: Array,
      reqired: false,
      default: () => ([]),
    },
    value: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  components: {
    VueUpload,
    Attachment,
  },
  data() {
    return {
      data: this.value,
    };
  },
  computed: {
    maximum() {
      return 10;
    },
    canAdd() {
      return this.data.length < this.maximum;
    },
  },
  methods: {
    onInputFilter(newOne, oldOne) {
      if (newOne && !oldOne) {
        // eslint-disable-next-line no-param-reassign
        newOne.blob = '';
        if ((window.URL || window.webkitURL) && URL.createObjectURL) {
          // eslint-disable-next-line no-param-reassign
          newOne.blob = URL.createObjectURL(newOne.file);
        }
      }
    },
    onInputFile() {
      this.$emit('input', this.data);
    },
    unset(file, index) {
      if (typeof file === 'object') {
        this.$refs.upload.remove(file);
      }
      if (typeof file === 'number' || typeof file === 'string') {
        this.data.splice(index, 1);
      }
    },
  },
};
</script>
